import React from "react";
import "./footer.scss";
import logo from "../../asset/logo.webp";

const footer = () => {
  return (
    <div className="logo">
      <div className="container-footer">
        <div className="container-atas">
          {/* <div className="container-logo">
            <img
              className="gambar-logo"
              src={logo}
              alt="logo-citraland-surabaya"
            />
          </div> */}
          <div className="container-deskripsi">
            <div className="alamat">
              <h2>Marketing Gallery</h2>
              <h1>Bumi Serpong Damai City</h1>
              <p>Lengkong Kulon, Pagedangan, Tangerang Regency, Banten 15331</p>
            </div>
            <div className="contact">Contact us : +6281319499502 </div>
            <div className="published">Published by Swandy Sutanto </div>

            <div className="privasi">
              <div className="kebijakan">
                <a href="/privacy-bsd.html">Kebijakan Privasi</a>
              </div>
              &nbsp;&nbsp;
              <div className="syarat">
                <a href="/terms-bsd.html">Syarat & Ketentuan</a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="disclaimer">
        Informasi Ini Dikelolah Oleh Marketing Independen, Bukan Merupakan
        Website Resmi Developer. Tujuan Untuk Kegiatan Pemasaran, Membantu
        Memberikan Referensi Informasi Produk Dapat Sewaktu Waktu Sesuai
        Kebijakan Pengembang
      </div>
      <div className="container-bawah"></div>
    </div>
  );
};

export default footer;
